module.exports = __webpack_public_path__ + "static/media/password_ok_img.ecae307a.svg";